import { v1ApiClient } from '@/services';
import type { PathParams, ResponseBody } from '@/shared/api/generated';

type DeleteNotificationPath = '/v1/notifications/{notification_id}';

type DeleteNotificationParams = PathParams<DeleteNotificationPath, 'delete'>;
type DeleteNotificationResponse = ResponseBody<
  DeleteNotificationPath,
  'delete'
>;

/**
 * 알림 삭제
 */
export const deleteNotification = ({
  notification_id,
}: DeleteNotificationParams): Promise<DeleteNotificationResponse> => {
  return v1ApiClient
    .delete(`/notifications/${notification_id}`)
    .then((res) => res.data);
};
